import React from "react";

export default function VendorFilter({ search, setSearch, status, setStatus }) {
  return (
    <div className="d-flex flex-wrap gap-2 mb-3 align-items-end">
      <div style={{ minWidth: 240 }}>
        <label className="form-label mb-1">Search</label>
        <input
          type="text"
          className="form-control"
          placeholder="Name, owner, email, socials..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>
      <div style={{ minWidth: 160 }}>
        <label className="form-label mb-1">Status</label>
        <select
          className="form-select"
          value={status}
          onChange={(e) => setStatus(e.target.value)}
        >
          <option value="all">All</option>
          <option value="active">Active</option>
          <option value="inactive">Inactive</option>
        </select>
      </div>
    </div>
  );
}
